import { Injectable } from '@angular/core';
import { DropdownQuestion } from '../models/question/question-dropdown';
import { TextboxQuestion } from '../models/question/question-textbox';
import { QuestionBase } from '../models/question/question-base';
import { QuestionModel } from '../models/question.model';
import { TypeEnum } from 'app/core/enum';
import { InputQuestion } from '../models/question/question-input';
import { CheckboxQuestion } from '../models/question/question-checkbox';
import { RadioButtonQuestion } from '../models/question/question-radio-button';
import { OptionQuestion } from '../models/question/question-option';

@Injectable()
export class QuestionService {

    getQuestions(questionsModel: QuestionModel[]): QuestionBase<any>[] {
        let questions: QuestionBase<any>[] = [];
        for (let questionModel of questionsModel) {
            switch (questionModel.type) {
                case TypeEnum.Input:
                    let input = new InputQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        type: 'input',
                        required: true,
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });
                    questions.push(input);
                    break;
                case TypeEnum.Checkbox:
                    let checkbox = new CheckboxQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        required: true,
                        options: questionModel.options.map(q => {
                            let rObj: OptionQuestion = new OptionQuestion();
                            rObj.key = q.name;
                            rObj.value = q.name;
                            rObj.score = q.score;
                            return rObj;
                        }),
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });

                    questions.push(checkbox);
                    break;
                case TypeEnum.Dropdown:
                    let dropdown = new DropdownQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        required: true,
                        options: questionModel.options.map(q => {
                            let rObj: OptionQuestion = new OptionQuestion();
                            rObj.key = q.name;
                            rObj.value = q.name;
                            rObj.score = q.score;
                            return rObj;
                        }),
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });

                    questions.push(dropdown);
                    break;
                case TypeEnum.Number:
                    let number = new InputQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        required: true,
                        type: 'number',
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });

                    questions.push(number);
                    break;
                case TypeEnum.RadioButton:
                    let radioButton = new RadioButtonQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        required: true,
                        options: questionModel.options.map(q => {
                            let rObj: OptionQuestion = new OptionQuestion();
                            rObj.id = q.id;
                            rObj.key = q.name;
                            rObj.value = q.name;
                            rObj.score = q.score;
                            return rObj;
                        }),
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });

                    questions.push(radioButton);
                    break;
                case TypeEnum.TextArea:
                    let textArea = new TextboxQuestion({
                        id: questionModel.questionBankQuestionId,
                        key: questionModel.key,
                        label: questionModel.label,
                        value: questionModel.value,
                        required: true,
                        order: questionModel.order,
                        readonly: questionModel.readOnly
                    });

                    questions.push(textArea);
                    break;
            }
        }

        return questions;
    }
}
